<template>
  <section class="why">
    <div class="container">
      <a-typography-title :level="1">
        <span>为什么选择星汉未来</span>
        <br v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.MD)" />
        <span>多活部署解决方案?</span>
      </a-typography-title>
      <a-row :gutter="[40,20]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :md="12" :xl="8">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              <template v-for="v in item.text">
                <p>{{ v }}</p>
              </template>
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_1"
                  @click="$Store.Page().openModal('modalOperate','reserve')">
          预约演示
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_why',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '全链路一键复制',
            text: [
              '降低应用部署难度',
              '无需业务分级，自动构建全量依赖服务',
              '统一管理各类中间件，实现全业务多活'
            ]
          },
          {
            title: '高度自动化',
            text: [
              '降低运维难度',
              '只需管理一套环境，变更及数据自动同步',
              '构建数据备份中心，自动处理数据一致性'
            ]
          },
          {
            title: '快速故障自愈',
            text: [
              '缩短故障时长',
              '环境、机型、数量等90%的配置自动化',
              '性能问题、资源故障等场景的自动处置'
            ]
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/planActive/';

.why {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg('@{imagePublic}bg_1.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @wh: 80px;
  @style: fade(@color_white, 50), @color_white;
  position: relative;
  min-height: 280px;
  padding: 15px 30px 30px;
  .gradientLinear(0deg, @style);
  border: 2px solid @color_14;
  border-radius: 8px;
  
  .loop(@i) when (@i<=3) {
    &.i_@{i} {
      &::before {
        background-position-x: -(-1+@i)*@wh;
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &::before {
    content: '';
    display: block;
    width: @wh;
    height: @wh;
    margin: 0 auto;
    .bg('@{image}why_icon.png', @wh*3, @wh);
  }
  
  h5.ant-typography {
    margin: @margin_mo 0 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    overflow: hidden;
    margin: @margin_mo 0 0;
    
    p {
      position: relative;
      padding-left: 15px;
      margin: 10px 0 0;
      .font(justify, @text+@line, @color_13, @text);
      
      &:nth-child(1) {
        margin: 0;
      }
      
      &::before {
        content: '';
        display: block;
        .position(absolute, 10px, auto, auto, 0);
        width: 6px;
        height: 6px;
        background: @color_10;
        border-radius: 50%;
      }
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .why {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    padding: 20px;
    min-height: auto;
    
    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      min-height: auto;
      
      p {
        .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
      }
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>